import { useEffect } from 'react';
import Approach from '../components/about/Approach';
import Testimonial from '../components/about/Testimonial';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Swiper from 'swiper';
import Stats from '../components/about/Stats';
import Contact from '../components/about/Contact';
import Team from '../components/about/Team';
import Blog from '../components/blogs/Blog';
import Banner from '../components/home/Banner';
import Collaborator from '../components/home/Collaborator';
import Service from '../components/home/Service';
import Project from '../components/home/Project';
import Potential from '../components/about/Potential';

const Home = ({
  setTab,
}: {
  setTab: React.Dispatch<React.SetStateAction<string>>;
}) => {
  useEffect(() => {
    new Swiper('.home3-success-stories-slider', {
      loop: true,
      spaceBetween: 30,
      slidesPerView: 3,
      pagination: {
        el: '.swiper-pagination11',
        clickable: true,
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
    });
    setTab('home');
  }, [setTab]);

  return (
    <>
      <Banner />
      <Collaborator />
      <Service />
      <Potential />
      {/* <Project />
      <Testimonial /> */}
      <Stats />
      <Approach />
      <Contact />
      <Team />
      <Blog />
    </>
  );
};

export default Home;
